import { render, staticRenderFns } from "./grap.vue?vue&type=template&id=1c284e24&scoped=true"
import script from "./grap.vue?vue&type=script&lang=js"
export * from "./grap.vue?vue&type=script&lang=js"
import style0 from "./grap.vue?vue&type=style&index=0&id=1c284e24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c284e24",
  null
  
)

export default component.exports